<template>
  <div class="login-layout-left" >
    <div
    class="login-layout-left-sider"
    :style="{
      flex: `0 0 ${clientWidth}px`,
      maxWidth: `${clientWidth}px`,
      minWidth: `${clientWidth}px`,
      width: `${clientWidth}px`,
    }"
    >
        <img class="login-layout-left-top" src="../../../assets/images/cloud_top@2x.png" />
        <img  v-if="logoUi.bgSrc" class="login-layout-left-middle" :style="{ width: imgWidth + 'px' }"
        :src="logoUi.bgSrc" />
        <img v-else class="login-layout-left-middle" :style="{ width: imgWidth + 'px' }"
        src="../../../assets/images/left_pic@2x.png" />
        <img class="login-layout-left-bottom" src="../../../assets/images/cloud_bottom@2x.png" />
    </div>
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';
export default {
  name: 'LeftRow',
  data() {
    return {
      logoUi: getLogo(),
      clientWidth: document.body.clientWidth * (750 / 1920),
      imgWidth: (document.body.clientWidth * (750 / 1920)) * (630 / 750),
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    const _this = this;
    window.onresize = () => (() => {
      _this.clientWidth = document.body.clientWidth * (750 / 1920);
      _this.imgWidth = (document.body.clientWidth * (750 / 1920)) * (630 / 750);
    })();
  },
};
</script>

<style lang="less" scoped>
.login-layout-left {
  position: relative;
  height: 100%;

  &-sider {
    background: linear-gradient(180deg, #2255CC 0%, #2255CC 0%, #4D7CE9 100%, #4D7CE9 100%);
    height: 100%;
    position: relative;
    min-width: 0;
    transition: all 0.2s;
  }
  &-top {
    position: absolute;
    top: 0%;
    right: 0%;
    width: 32%;
  }

  &-middle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  &-bottom {
    width: 32%;
    position: absolute;
    bottom: 0%;
    left: 0%;
  }
}
</style>
